import React from 'react';
import Icon from '../../icons';

const FormTextInput = (field) => {
    const showError = (field.meta.touched || field.meta.submitFailed) && (field.meta.error || field.meta.submitError);
    return (
    <div className={`${field.formGroup ? field.formGroup :'colFlex'} ${field.wrapperClass ? field.wrapperClass :''} ${showError ? 'errorMsg' : ''}`}>
        {field.label && <div className={`${field.labeldivclass}`}><label className={`${field.labelClass ? field.labelClass : ''} `}>{field.label}{field.isRequired && <sup>*</sup>}
            {field.helpText && <span className="quickTooltip-bottom" data-quicktooltip={field.helpText}><Icon name="info" className="icon ml greyInfoIcon" /></span>}
        </label></div>}
        <div className={`${field.divClass ? field.divClass : ''} `}>
        <input {...field.input} type="text" className={`${field.inputClass ? field.inputClass : ''} ${field.isDisabled ?"disabled":""}`} maxLength={field.maxLength} placeholder={field.placeholder} disabled={field.isDisabled} onKeyUp={(e) =>{field.onKeyUp ? field.onKeyUp(e) :null}} onBlur={(e)=>{ field.input.onBlur(e); if(field.onFieldValueChange) field.onFieldValueChange(e); }} autoFocus={field.autoFocus} />
        <p>{showError &&
            <span>{field.meta.error || field.meta.submitError}</span>}</p>
        {field.description &&
            <small className="fieldDescription">{field.description}</small>}
        </div>
    </div>
    );
}

export default FormTextInput;